'use strict';
var __assign =
    (this && this.__assign) ||
    function () {
        return (
            (__assign =
                Object.assign ||
                function (e) {
                    for (var t, n = 1, r = arguments.length; n < r; n++)
                        for (var o in (t = arguments[n])) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                    return e;
                }),
            __assign.apply(this, arguments)
        );
    };
/**
 * @license Angular v<unknown>
 * (c) 2010-2024 Google LLC. https://angular.io/
 * License: MIT
 */ !(function (e) {
    'function' == typeof define && define.amd ? define(e) : e();
})(function () {
    var e = globalThis;
    function t(t) {
        return (e.__Zone_symbol_prefix || '__zone_symbol__') + t;
    }
    function n() {
        var n,
            r = e.performance;
        function o(e) {
            r && r.mark && r.mark(e);
        }
        function a(e, t) {
            r && r.measure && r.measure(e, t);
        }
        o('Zone');
        var i = (function () {
            function r(e, t) {
                (this._parent = e),
                    (this._name = t ? t.name || 'unnamed' : '<root>'),
                    (this._properties = (t && t.properties) || {}),
                    (this._zoneDelegate = new u(this, this._parent && this._parent._zoneDelegate, t));
            }
            return (
                (r.assertZonePatched = function () {
                    if (e.Promise !== O.ZoneAwarePromise)
                        throw new Error(
                            'Zone.js has detected that ZoneAwarePromise `(window|global).Promise` has been overwritten.\nMost likely cause is that a Promise polyfill has been loaded after Zone.js (Polyfilling Promise api is not necessary when zone.js is loaded. If you must load one, do so before loading zone.js.)',
                        );
                }),
                Object.defineProperty(r, 'root', {
                    get: function () {
                        for (var e = n.current; e.parent; ) e = e.parent;
                        return e;
                    },
                    enumerable: !1,
                    configurable: !0,
                }),
                Object.defineProperty(r, 'current', {
                    get: function () {
                        return j.zone;
                    },
                    enumerable: !1,
                    configurable: !0,
                }),
                Object.defineProperty(r, 'currentTask', {
                    get: function () {
                        return z;
                    },
                    enumerable: !1,
                    configurable: !0,
                }),
                (r.__load_patch = function (r, i, s) {
                    if ((void 0 === s && (s = !1), O.hasOwnProperty(r))) {
                        var c = !0 === e[t('forceDuplicateZoneCheck')];
                        if (!s && c) throw Error('Already loaded patch: ' + r);
                    } else if (!e['__Zone_disable_' + r]) {
                        var u = 'Zone:' + r;
                        o(u), (O[r] = i(e, n, C)), a(u, u);
                    }
                }),
                Object.defineProperty(r.prototype, 'parent', {
                    get: function () {
                        return this._parent;
                    },
                    enumerable: !1,
                    configurable: !0,
                }),
                Object.defineProperty(r.prototype, 'name', {
                    get: function () {
                        return this._name;
                    },
                    enumerable: !1,
                    configurable: !0,
                }),
                (r.prototype.get = function (e) {
                    var t = this.getZoneWith(e);
                    if (t) return t._properties[e];
                }),
                (r.prototype.getZoneWith = function (e) {
                    for (var t = this; t; ) {
                        if (t._properties.hasOwnProperty(e)) return t;
                        t = t._parent;
                    }
                    return null;
                }),
                (r.prototype.fork = function (e) {
                    if (!e) throw new Error('ZoneSpec required!');
                    return this._zoneDelegate.fork(this, e);
                }),
                (r.prototype.wrap = function (e, t) {
                    if ('function' != typeof e) throw new Error('Expecting function got: ' + e);
                    var n = this._zoneDelegate.intercept(this, e, t),
                        r = this;
                    return function () {
                        return r.runGuarded(n, this, arguments, t);
                    };
                }),
                (r.prototype.run = function (e, t, n, r) {
                    j = { parent: j, zone: this };
                    try {
                        return this._zoneDelegate.invoke(this, e, t, n, r);
                    } finally {
                        j = j.parent;
                    }
                }),
                (r.prototype.runGuarded = function (e, t, n, r) {
                    void 0 === t && (t = null), (j = { parent: j, zone: this });
                    try {
                        try {
                            return this._zoneDelegate.invoke(this, e, t, n, r);
                        } catch (e) {
                            if (this._zoneDelegate.handleError(this, e)) throw e;
                        }
                    } finally {
                        j = j.parent;
                    }
                }),
                (r.prototype.runTask = function (e, t, n) {
                    if (e.zone != this)
                        throw new Error(
                            'A task can only be run in the zone of creation! (Creation: ' +
                                (e.zone || y).name +
                                '; Execution: ' +
                                this.name +
                                ')',
                        );
                    if (e.state !== m || (e.type !== D && e.type !== Z)) {
                        var r = e.state != E;
                        r && e._transitionTo(E, b), e.runCount++;
                        var o = z;
                        (z = e), (j = { parent: j, zone: this });
                        try {
                            e.type == Z && e.data && !e.data.isPeriodic && (e.cancelFn = void 0);
                            try {
                                return this._zoneDelegate.invokeTask(this, e, t, n);
                            } catch (e) {
                                if (this._zoneDelegate.handleError(this, e)) throw e;
                            }
                        } finally {
                            e.state !== m &&
                                e.state !== S &&
                                (e.type == D || (e.data && e.data.isPeriodic)
                                    ? r && e._transitionTo(b, E)
                                    : ((e.runCount = 0), this._updateTaskCount(e, -1), r && e._transitionTo(m, E, m))),
                                (j = j.parent),
                                (z = o);
                        }
                    }
                }),
                (r.prototype.scheduleTask = function (e) {
                    if (e.zone && e.zone !== this)
                        for (var t = this; t; ) {
                            if (t === e.zone)
                                throw Error(
                                    'can not reschedule task to '
                                        .concat(this.name, ' which is descendants of the original zone ')
                                        .concat(e.zone.name),
                                );
                            t = t.parent;
                        }
                    e._transitionTo(T, m);
                    var n = [];
                    (e._zoneDelegates = n), (e._zone = this);
                    try {
                        e = this._zoneDelegate.scheduleTask(this, e);
                    } catch (t) {
                        throw (e._transitionTo(S, T, m), this._zoneDelegate.handleError(this, t), t);
                    }
                    return (
                        e._zoneDelegates === n && this._updateTaskCount(e, 1), e.state == T && e._transitionTo(b, T), e
                    );
                }),
                (r.prototype.scheduleMicroTask = function (e, t, n, r) {
                    return this.scheduleTask(new l(P, e, t, n, r, void 0));
                }),
                (r.prototype.scheduleMacroTask = function (e, t, n, r, o) {
                    return this.scheduleTask(new l(Z, e, t, n, r, o));
                }),
                (r.prototype.scheduleEventTask = function (e, t, n, r, o) {
                    return this.scheduleTask(new l(D, e, t, n, r, o));
                }),
                (r.prototype.cancelTask = function (e) {
                    if (e.zone != this)
                        throw new Error(
                            'A task can only be cancelled in the zone of creation! (Creation: ' +
                                (e.zone || y).name +
                                '; Execution: ' +
                                this.name +
                                ')',
                        );
                    if (e.state === b || e.state === E) {
                        e._transitionTo(w, b, E);
                        try {
                            this._zoneDelegate.cancelTask(this, e);
                        } catch (t) {
                            throw (e._transitionTo(S, w), this._zoneDelegate.handleError(this, t), t);
                        }
                        return this._updateTaskCount(e, -1), e._transitionTo(m, w), (e.runCount = 0), e;
                    }
                }),
                (r.prototype._updateTaskCount = function (e, t) {
                    var n = e._zoneDelegates;
                    -1 == t && (e._zoneDelegates = null);
                    for (var r = 0; r < n.length; r++) n[r]._updateTaskCount(e.type, t);
                }),
                r
            );
        })();
        (n = i).__symbol__ = t;
        var s,
            c = {
                name: '',
                onHasTask: function (e, t, n, r) {
                    return e.hasTask(n, r);
                },
                onScheduleTask: function (e, t, n, r) {
                    return e.scheduleTask(n, r);
                },
                onInvokeTask: function (e, t, n, r, o, a) {
                    return e.invokeTask(n, r, o, a);
                },
                onCancelTask: function (e, t, n, r) {
                    return e.cancelTask(n, r);
                },
            },
            u = (function () {
                function e(e, t, n) {
                    (this._taskCounts = { microTask: 0, macroTask: 0, eventTask: 0 }),
                        (this._zone = e),
                        (this._parentDelegate = t),
                        (this._forkZS = n && (n && n.onFork ? n : t._forkZS)),
                        (this._forkDlgt = n && (n.onFork ? t : t._forkDlgt)),
                        (this._forkCurrZone = n && (n.onFork ? this._zone : t._forkCurrZone)),
                        (this._interceptZS = n && (n.onIntercept ? n : t._interceptZS)),
                        (this._interceptDlgt = n && (n.onIntercept ? t : t._interceptDlgt)),
                        (this._interceptCurrZone = n && (n.onIntercept ? this._zone : t._interceptCurrZone)),
                        (this._invokeZS = n && (n.onInvoke ? n : t._invokeZS)),
                        (this._invokeDlgt = n && (n.onInvoke ? t : t._invokeDlgt)),
                        (this._invokeCurrZone = n && (n.onInvoke ? this._zone : t._invokeCurrZone)),
                        (this._handleErrorZS = n && (n.onHandleError ? n : t._handleErrorZS)),
                        (this._handleErrorDlgt = n && (n.onHandleError ? t : t._handleErrorDlgt)),
                        (this._handleErrorCurrZone = n && (n.onHandleError ? this._zone : t._handleErrorCurrZone)),
                        (this._scheduleTaskZS = n && (n.onScheduleTask ? n : t._scheduleTaskZS)),
                        (this._scheduleTaskDlgt = n && (n.onScheduleTask ? t : t._scheduleTaskDlgt)),
                        (this._scheduleTaskCurrZone = n && (n.onScheduleTask ? this._zone : t._scheduleTaskCurrZone)),
                        (this._invokeTaskZS = n && (n.onInvokeTask ? n : t._invokeTaskZS)),
                        (this._invokeTaskDlgt = n && (n.onInvokeTask ? t : t._invokeTaskDlgt)),
                        (this._invokeTaskCurrZone = n && (n.onInvokeTask ? this._zone : t._invokeTaskCurrZone)),
                        (this._cancelTaskZS = n && (n.onCancelTask ? n : t._cancelTaskZS)),
                        (this._cancelTaskDlgt = n && (n.onCancelTask ? t : t._cancelTaskDlgt)),
                        (this._cancelTaskCurrZone = n && (n.onCancelTask ? this._zone : t._cancelTaskCurrZone)),
                        (this._hasTaskZS = null),
                        (this._hasTaskDlgt = null),
                        (this._hasTaskDlgtOwner = null),
                        (this._hasTaskCurrZone = null);
                    var r = n && n.onHasTask;
                    (r || (t && t._hasTaskZS)) &&
                        ((this._hasTaskZS = r ? n : c),
                        (this._hasTaskDlgt = t),
                        (this._hasTaskDlgtOwner = this),
                        (this._hasTaskCurrZone = this._zone),
                        n.onScheduleTask ||
                            ((this._scheduleTaskZS = c),
                            (this._scheduleTaskDlgt = t),
                            (this._scheduleTaskCurrZone = this._zone)),
                        n.onInvokeTask ||
                            ((this._invokeTaskZS = c),
                            (this._invokeTaskDlgt = t),
                            (this._invokeTaskCurrZone = this._zone)),
                        n.onCancelTask ||
                            ((this._cancelTaskZS = c),
                            (this._cancelTaskDlgt = t),
                            (this._cancelTaskCurrZone = this._zone)));
                }
                return (
                    Object.defineProperty(e.prototype, 'zone', {
                        get: function () {
                            return this._zone;
                        },
                        enumerable: !1,
                        configurable: !0,
                    }),
                    (e.prototype.fork = function (e, t) {
                        return this._forkZS ? this._forkZS.onFork(this._forkDlgt, this.zone, e, t) : new i(e, t);
                    }),
                    (e.prototype.intercept = function (e, t, n) {
                        return this._interceptZS
                            ? this._interceptZS.onIntercept(this._interceptDlgt, this._interceptCurrZone, e, t, n)
                            : t;
                    }),
                    (e.prototype.invoke = function (e, t, n, r, o) {
                        return this._invokeZS
                            ? this._invokeZS.onInvoke(this._invokeDlgt, this._invokeCurrZone, e, t, n, r, o)
                            : t.apply(n, r);
                    }),
                    (e.prototype.handleError = function (e, t) {
                        return (
                            !this._handleErrorZS ||
                            this._handleErrorZS.onHandleError(this._handleErrorDlgt, this._handleErrorCurrZone, e, t)
                        );
                    }),
                    (e.prototype.scheduleTask = function (e, t) {
                        var n = t;
                        if (this._scheduleTaskZS)
                            this._hasTaskZS && n._zoneDelegates.push(this._hasTaskDlgtOwner),
                                (n = this._scheduleTaskZS.onScheduleTask(
                                    this._scheduleTaskDlgt,
                                    this._scheduleTaskCurrZone,
                                    e,
                                    t,
                                )) || (n = t);
                        else if (t.scheduleFn) t.scheduleFn(t);
                        else {
                            if (t.type != P) throw new Error('Task is missing scheduleFn.');
                            g(t);
                        }
                        return n;
                    }),
                    (e.prototype.invokeTask = function (e, t, n, r) {
                        return this._invokeTaskZS
                            ? this._invokeTaskZS.onInvokeTask(
                                  this._invokeTaskDlgt,
                                  this._invokeTaskCurrZone,
                                  e,
                                  t,
                                  n,
                                  r,
                              )
                            : t.callback.apply(n, r);
                    }),
                    (e.prototype.cancelTask = function (e, t) {
                        var n;
                        if (this._cancelTaskZS)
                            n = this._cancelTaskZS.onCancelTask(this._cancelTaskDlgt, this._cancelTaskCurrZone, e, t);
                        else {
                            if (!t.cancelFn) throw Error('Task is not cancelable');
                            n = t.cancelFn(t);
                        }
                        return n;
                    }),
                    (e.prototype.hasTask = function (e, t) {
                        try {
                            this._hasTaskZS &&
                                this._hasTaskZS.onHasTask(this._hasTaskDlgt, this._hasTaskCurrZone, e, t);
                        } catch (t) {
                            this.handleError(e, t);
                        }
                    }),
                    (e.prototype._updateTaskCount = function (e, t) {
                        var n = this._taskCounts,
                            r = n[e],
                            o = (n[e] = r + t);
                        if (o < 0) throw new Error('More tasks executed then were scheduled.');
                        (0 != r && 0 != o) ||
                            this.hasTask(this._zone, {
                                microTask: n.microTask > 0,
                                macroTask: n.macroTask > 0,
                                eventTask: n.eventTask > 0,
                                change: e,
                            });
                    }),
                    e
                );
            })(),
            l = (function () {
                function t(n, r, o, a, i, s) {
                    if (
                        ((this._zone = null),
                        (this.runCount = 0),
                        (this._zoneDelegates = null),
                        (this._state = 'notScheduled'),
                        (this.type = n),
                        (this.source = r),
                        (this.data = a),
                        (this.scheduleFn = i),
                        (this.cancelFn = s),
                        !o)
                    )
                        throw new Error('callback is not defined');
                    this.callback = o;
                    var c = this;
                    this.invoke =
                        n === D && a && a.useG
                            ? t.invokeTask
                            : function () {
                                  return t.invokeTask.call(e, c, this, arguments);
                              };
                }
                return (
                    (t.invokeTask = function (e, t, n) {
                        e || (e = this), I++;
                        try {
                            return e.runCount++, e.zone.runTask(e, t, n);
                        } finally {
                            1 == I && k(), I--;
                        }
                    }),
                    Object.defineProperty(t.prototype, 'zone', {
                        get: function () {
                            return this._zone;
                        },
                        enumerable: !1,
                        configurable: !0,
                    }),
                    Object.defineProperty(t.prototype, 'state', {
                        get: function () {
                            return this._state;
                        },
                        enumerable: !1,
                        configurable: !0,
                    }),
                    (t.prototype.cancelScheduleRequest = function () {
                        this._transitionTo(m, T);
                    }),
                    (t.prototype._transitionTo = function (e, t, n) {
                        if (this._state !== t && this._state !== n)
                            throw new Error(
                                ''
                                    .concat(this.type, " '")
                                    .concat(this.source, "': can not transition to '")
                                    .concat(e, "', expecting state '")
                                    .concat(t, "'")
                                    .concat(n ? " or '" + n + "'" : '', ", was '")
                                    .concat(this._state, "'."),
                            );
                        (this._state = e), e == m && (this._zoneDelegates = null);
                    }),
                    (t.prototype.toString = function () {
                        return this.data && void 0 !== this.data.handleId
                            ? this.data.handleId.toString()
                            : Object.prototype.toString.call(this);
                    }),
                    (t.prototype.toJSON = function () {
                        return {
                            type: this.type,
                            state: this.state,
                            source: this.source,
                            zone: this.zone.name,
                            runCount: this.runCount,
                        };
                    }),
                    t
                );
            })(),
            f = t('setTimeout'),
            h = t('Promise'),
            p = t('then'),
            v = [],
            d = !1;
        function _(t) {
            if ((s || (e[h] && (s = e[h].resolve(0))), s)) {
                var n = s[p];
                n || (n = s.then), n.call(s, t);
            } else e[f](t, 0);
        }
        function g(e) {
            0 === I && 0 === v.length && _(k), e && v.push(e);
        }
        function k() {
            if (!d) {
                for (d = !0; v.length; ) {
                    var e = v;
                    v = [];
                    for (var t = 0; t < e.length; t++) {
                        var n = e[t];
                        try {
                            n.zone.runTask(n, null, null);
                        } catch (e) {
                            C.onUnhandledError(e);
                        }
                    }
                }
                C.microtaskDrainDone(), (d = !1);
            }
        }
        var y = { name: 'NO ZONE' },
            m = 'notScheduled',
            T = 'scheduling',
            b = 'scheduled',
            E = 'running',
            w = 'canceling',
            S = 'unknown',
            P = 'microTask',
            Z = 'macroTask',
            D = 'eventTask',
            O = {},
            C = {
                symbol: t,
                currentZoneFrame: function () {
                    return j;
                },
                onUnhandledError: R,
                microtaskDrainDone: R,
                scheduleMicroTask: g,
                showUncaughtError: function () {
                    return !i[t('ignoreConsoleErrorUncaughtError')];
                },
                patchEventTarget: function () {
                    return [];
                },
                patchOnProperties: R,
                patchMethod: function () {
                    return R;
                },
                bindArguments: function () {
                    return [];
                },
                patchThen: function () {
                    return R;
                },
                patchMacroTask: function () {
                    return R;
                },
                patchEventPrototype: function () {
                    return R;
                },
                isIEOrEdge: function () {
                    return !1;
                },
                getGlobalObjects: function () {},
                ObjectDefineProperty: function () {
                    return R;
                },
                ObjectGetOwnPropertyDescriptor: function () {},
                ObjectCreate: function () {},
                ArraySlice: function () {
                    return [];
                },
                patchClass: function () {
                    return R;
                },
                wrapWithCurrentZone: function () {
                    return R;
                },
                filterProperties: function () {
                    return [];
                },
                attachOriginToPatched: function () {
                    return R;
                },
                _redefineProperty: function () {
                    return R;
                },
                patchCallbacks: function () {
                    return R;
                },
                nativeScheduleMicroTask: _,
            },
            j = { parent: null, zone: new i(null, null) },
            z = null,
            I = 0;
        function R() {}
        return a('Zone', 'Zone'), i;
    }
    var r = Object.getOwnPropertyDescriptor,
        o = Object.defineProperty,
        a = Object.getPrototypeOf,
        i = Object.create,
        s = Array.prototype.slice,
        c = 'addEventListener',
        u = 'removeEventListener',
        l = t(c),
        f = t(u),
        h = 'true',
        p = 'false',
        v = t('');
    function d(e, t) {
        return Zone.current.wrap(e, t);
    }
    function _(e, t, n, r, o) {
        return Zone.current.scheduleMacroTask(e, t, n, r, o);
    }
    var g = t,
        k = 'undefined' != typeof window,
        y = k ? window : void 0,
        m = (k && y) || globalThis,
        T = 'removeAttribute';
    function b(e, t) {
        for (var n = e.length - 1; n >= 0; n--) 'function' == typeof e[n] && (e[n] = d(e[n], t + '_' + n));
        return e;
    }
    function E(e) {
        return !e || (!1 !== e.writable && !('function' == typeof e.get && void 0 === e.set));
    }
    var w = 'undefined' != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope,
        S = !('nw' in m) && void 0 !== m.process && '[object process]' === m.process.toString(),
        P = !S && !w && !(!k || !y.HTMLElement),
        Z = void 0 !== m.process && '[object process]' === m.process.toString() && !w && !(!k || !y.HTMLElement),
        D = {},
        O = function (e) {
            if ((e = e || m.event)) {
                var t = D[e.type];
                t || (t = D[e.type] = g('ON_PROPERTY' + e.type));
                var n,
                    r = this || e.target || m,
                    o = r[t];
                return (
                    P && r === y && 'error' === e.type
                        ? !0 === (n = o && o.call(this, e.message, e.filename, e.lineno, e.colno, e.error)) &&
                          e.preventDefault()
                        : null == (n = o && o.apply(this, arguments)) || n || e.preventDefault(),
                    n
                );
            }
        };
    function C(e, t, n) {
        var a = r(e, t);
        if ((!a && n && r(n, t) && (a = { enumerable: !0, configurable: !0 }), a && a.configurable)) {
            var i = g('on' + t + 'patched');
            if (!e.hasOwnProperty(i) || !e[i]) {
                delete a.writable, delete a.value;
                var s = a.get,
                    c = a.set,
                    u = t.slice(2),
                    l = D[u];
                l || (l = D[u] = g('ON_PROPERTY' + u)),
                    (a.set = function (t) {
                        var n = this;
                        n || e !== m || (n = m),
                            n &&
                                ('function' == typeof n[l] && n.removeEventListener(u, O),
                                c && c.call(n, null),
                                (n[l] = t),
                                'function' == typeof t && n.addEventListener(u, O, !1));
                    }),
                    (a.get = function () {
                        var n = this;
                        if ((n || e !== m || (n = m), !n)) return null;
                        var r = n[l];
                        if (r) return r;
                        if (s) {
                            var o = s.call(this);
                            if (o) return a.set.call(this, o), 'function' == typeof n[T] && n.removeAttribute(t), o;
                        }
                        return null;
                    }),
                    o(e, t, a),
                    (e[i] = !0);
            }
        }
    }
    function j(e, t, n) {
        if (t) for (var r = 0; r < t.length; r++) C(e, 'on' + t[r], n);
        else {
            var o = [];
            for (var a in e) 'on' == a.slice(0, 2) && o.push(a);
            for (var i = 0; i < o.length; i++) C(e, o[i], n);
        }
    }
    var z = g('originalInstance');
    function I(e) {
        var t = m[e];
        if (t) {
            (m[g(e)] = t),
                (m[e] = function () {
                    var n = b(arguments, e);
                    switch (n.length) {
                        case 0:
                            this[z] = new t();
                            break;
                        case 1:
                            this[z] = new t(n[0]);
                            break;
                        case 2:
                            this[z] = new t(n[0], n[1]);
                            break;
                        case 3:
                            this[z] = new t(n[0], n[1], n[2]);
                            break;
                        case 4:
                            this[z] = new t(n[0], n[1], n[2], n[3]);
                            break;
                        default:
                            throw new Error('Arg list too long.');
                    }
                }),
                N(m[e], t);
            var n,
                r = new t(function () {});
            for (n in r)
                ('XMLHttpRequest' === e && 'responseBlob' === n) ||
                    (function (t) {
                        'function' == typeof r[t]
                            ? (m[e].prototype[t] = function () {
                                  return this[z][t].apply(this[z], arguments);
                              })
                            : o(m[e].prototype, t, {
                                  set: function (n) {
                                      'function' == typeof n
                                          ? ((this[z][t] = d(n, e + '.' + t)), N(this[z][t], n))
                                          : (this[z][t] = n);
                                  },
                                  get: function () {
                                      return this[z][t];
                                  },
                              });
                    })(n);
            for (n in t) 'prototype' !== n && t.hasOwnProperty(n) && (m[e][n] = t[n]);
        }
    }
    function R(e, t, n) {
        for (var o = e; o && !o.hasOwnProperty(t); ) o = a(o);
        !o && e[t] && (o = e);
        var i = g(t),
            s = null;
        if (o && (!(s = o[i]) || !o.hasOwnProperty(i)) && ((s = o[i] = o[t]), E(o && r(o, t)))) {
            var c = n(s, i, t);
            (o[t] = function () {
                return c(this, arguments);
            }),
                N(o[t], s);
        }
        return s;
    }
    function M(e, t, n) {
        var r = null;
        function o(e) {
            var t = e.data;
            return (
                (t.args[t.cbIdx] = function () {
                    e.invoke.apply(this, arguments);
                }),
                r.apply(t.target, t.args),
                e
            );
        }
        r = R(e, t, function (e) {
            return function (t, r) {
                var a = n(t, r);
                return a.cbIdx >= 0 && 'function' == typeof r[a.cbIdx] ? _(a.name, r[a.cbIdx], a, o) : e.apply(t, r);
            };
        });
    }
    function N(e, t) {
        e[g('OriginalDelegate')] = t;
    }
    var A = !1,
        L = !1;
    function H() {
        if (A) return L;
        A = !0;
        try {
            var e = y.navigator.userAgent;
            (-1 === e.indexOf('MSIE ') && -1 === e.indexOf('Trident/') && -1 === e.indexOf('Edge/')) || (L = !0);
        } catch (e) {}
        return L;
    }
    var x = !1;
    if ('undefined' != typeof window)
        try {
            var F = Object.defineProperty({}, 'passive', {
                get: function () {
                    x = !0;
                },
            });
            window.addEventListener('test', F, F), window.removeEventListener('test', F, F);
        } catch (e) {
            x = !1;
        }
    var q = { useG: !0 },
        G = {},
        W = {},
        B = new RegExp('^' + v + '(\\w+)(true|false)$'),
        U = g('propagationStopped');
    function V(e, t) {
        var n = (t ? t(e) : e) + p,
            r = (t ? t(e) : e) + h,
            o = v + n,
            a = v + r;
        (G[e] = {}), (G[e][p] = o), (G[e][h] = a);
    }
    function X(e, t, n, r) {
        var o = (r && r.add) || c,
            i = (r && r.rm) || u,
            s = (r && r.listeners) || 'eventListeners',
            l = (r && r.rmAll) || 'removeAllListeners',
            f = g(o),
            d = '.' + o + ':',
            _ = 'prependListener',
            k = '.' + _ + ':',
            y = function (e, t, n) {
                if (!e.isRemoved) {
                    var r,
                        o = e.callback;
                    'object' == typeof o &&
                        o.handleEvent &&
                        ((e.callback = function (e) {
                            return o.handleEvent(e);
                        }),
                        (e.originalDelegate = o));
                    try {
                        e.invoke(e, t, [n]);
                    } catch (e) {
                        r = e;
                    }
                    var a = e.options;
                    return (
                        a &&
                            'object' == typeof a &&
                            a.once &&
                            t[i].call(t, n.type, e.originalDelegate ? e.originalDelegate : e.callback, a),
                        r
                    );
                }
            };
        function m(n, r, o) {
            if ((r = r || e.event)) {
                var a = n || r.target || e,
                    i = a[G[r.type][o ? h : p]];
                if (i) {
                    var s = [];
                    if (1 === i.length) (l = y(i[0], a, r)) && s.push(l);
                    else
                        for (var c = i.slice(), u = 0; u < c.length && (!r || !0 !== r[U]); u++) {
                            var l;
                            (l = y(c[u], a, r)) && s.push(l);
                        }
                    if (1 === s.length) throw s[0];
                    var f = function (e) {
                        var n = s[e];
                        t.nativeScheduleMicroTask(function () {
                            throw n;
                        });
                    };
                    for (u = 0; u < s.length; u++) f(u);
                }
            }
        }
        var T = function (e) {
                return m(this, e, !1);
            },
            b = function (e) {
                return m(this, e, !0);
            };
        function E(t, n) {
            if (!t) return !1;
            var r = !0;
            n && void 0 !== n.useG && (r = n.useG);
            var c = n && n.vh,
                u = !0;
            n && void 0 !== n.chkDup && (u = n.chkDup);
            var y = !1;
            n && void 0 !== n.rt && (y = n.rt);
            for (var m = t; m && !m.hasOwnProperty(o); ) m = a(m);
            if ((!m && t[o] && (m = t), !m)) return !1;
            if (m[f]) return !1;
            var E,
                w = n && n.eventNameToString,
                P = {},
                Z = (m[f] = m[o]),
                D = (m[g(i)] = m[i]),
                O = (m[g(s)] = m[s]),
                C = (m[g(l)] = m[l]);
            n && n.prepend && (E = m[g(n.prepend)] = m[n.prepend]);
            var j = r
                    ? function (e) {
                          if (!P.isExisting) return Z.call(P.target, P.eventName, P.capture ? b : T, P.options);
                      }
                    : function (e) {
                          return Z.call(P.target, P.eventName, e.invoke, P.options);
                      },
                z = r
                    ? function (e) {
                          if (!e.isRemoved) {
                              var t = G[e.eventName],
                                  n = void 0;
                              t && (n = t[e.capture ? h : p]);
                              var r = n && e.target[n];
                              if (r)
                                  for (var o = 0; o < r.length; o++)
                                      if (r[o] === e) {
                                          r.splice(o, 1),
                                              (e.isRemoved = !0),
                                              0 === r.length && ((e.allRemoved = !0), (e.target[n] = null));
                                          break;
                                      }
                          }
                          if (e.allRemoved) return D.call(e.target, e.eventName, e.capture ? b : T, e.options);
                      }
                    : function (e) {
                          return D.call(e.target, e.eventName, e.invoke, e.options);
                      },
                I =
                    n && n.diff
                        ? n.diff
                        : function (e, t) {
                              var n = typeof t;
                              return (
                                  ('function' === n && e.callback === t) || ('object' === n && e.originalDelegate === t)
                              );
                          },
                R = Zone[g('UNPATCHED_EVENTS')],
                M = e[g('PASSIVE_EVENTS')],
                A = function (t, o, a, i, s, l) {
                    return (
                        void 0 === s && (s = !1),
                        void 0 === l && (l = !1),
                        function () {
                            var f = this || e,
                                v = arguments[0];
                            n && n.transferEventName && (v = n.transferEventName(v));
                            var d = arguments[1];
                            if (!d) return t.apply(this, arguments);
                            if (S && 'uncaughtException' === v) return t.apply(this, arguments);
                            var _ = !1;
                            if ('function' != typeof d) {
                                if (!d.handleEvent) return t.apply(this, arguments);
                                _ = !0;
                            }
                            if (!c || c(t, d, f, arguments)) {
                                var g = x && !!M && -1 !== M.indexOf(v),
                                    k = (function e(t, n) {
                                        return !x && 'object' == typeof t && t
                                            ? !!t.capture
                                            : x && n
                                            ? 'boolean' == typeof t
                                                ? { capture: t, passive: !0 }
                                                : t
                                                ? 'object' == typeof t && !1 !== t.passive
                                                    ? __assign(__assign({}, t), { passive: !0 })
                                                    : t
                                                : { passive: !0 }
                                            : t;
                                    })(arguments[2], g),
                                    y = null == k ? void 0 : k.signal;
                                if (!(null == y ? void 0 : y.aborted)) {
                                    if (R)
                                        for (var m = 0; m < R.length; m++)
                                            if (v === R[m]) return g ? t.call(f, v, d, k) : t.apply(this, arguments);
                                    var T = !!k && ('boolean' == typeof k || k.capture),
                                        b = !(!k || 'object' != typeof k) && k.once,
                                        E = Zone.current,
                                        Z = G[v];
                                    Z || (V(v, w), (Z = G[v]));
                                    var D,
                                        O = Z[T ? h : p],
                                        C = f[O],
                                        j = !1;
                                    if (C) {
                                        if (((j = !0), u)) for (m = 0; m < C.length; m++) if (I(C[m], d)) return;
                                    } else C = f[O] = [];
                                    var z = f.constructor.name,
                                        N = W[z];
                                    N && (D = N[v]),
                                        D || (D = z + o + (w ? w(v) : v)),
                                        (P.options = k),
                                        b && (P.options.once = !1),
                                        (P.target = f),
                                        (P.capture = T),
                                        (P.eventName = v),
                                        (P.isExisting = j);
                                    var A = r ? q : void 0;
                                    A && (A.taskData = P), y && (P.options.signal = void 0);
                                    var L = E.scheduleEventTask(D, d, A, a, i);
                                    if (y) {
                                        P.options.signal = y;
                                        var H = function () {
                                            return L.zone.cancelTask(L);
                                        };
                                        t.call(y, 'abort', H, { once: !0 }),
                                            A &&
                                                (A.removeAbortListener = function () {
                                                    return y.removeEventListener('abort', H);
                                                });
                                    }
                                    return (
                                        (P.target = null),
                                        A && (A.taskData = null),
                                        b && (k.once = !0),
                                        (x || 'boolean' != typeof L.options) && (L.options = k),
                                        (L.target = f),
                                        (L.capture = T),
                                        (L.eventName = v),
                                        _ && (L.originalDelegate = d),
                                        l ? C.unshift(L) : C.push(L),
                                        s ? f : void 0
                                    );
                                }
                            }
                        }
                    );
                };
            return (
                (m[o] = A(Z, d, j, z, y)),
                E &&
                    (m[_] = A(
                        E,
                        k,
                        function (e) {
                            return E.call(P.target, P.eventName, e.invoke, P.options);
                        },
                        z,
                        y,
                        !0,
                    )),
                (m[i] = function () {
                    var t = this || e,
                        r = arguments[0];
                    n && n.transferEventName && (r = n.transferEventName(r));
                    var o = arguments[2],
                        a = !!o && ('boolean' == typeof o || o.capture),
                        i = arguments[1];
                    if (!i) return D.apply(this, arguments);
                    if (!c || c(D, i, t, arguments)) {
                        var s,
                            u = G[r];
                        u && (s = u[a ? h : p]);
                        var l = s && t[s];
                        if (l)
                            for (var f = 0; f < l.length; f++) {
                                var d = l[f];
                                if (I(d, i)) {
                                    l.splice(f, 1),
                                        (d.isRemoved = !0),
                                        0 === l.length &&
                                            ((d.allRemoved = !0),
                                            (t[s] = null),
                                            a || 'string' != typeof r || (t[v + 'ON_PROPERTY' + r] = null));
                                    var _ = d.data;
                                    return (
                                        (null == _ ? void 0 : _.removeAbortListener) &&
                                            (_.removeAbortListener(), (_.removeAbortListener = null)),
                                        d.zone.cancelTask(d),
                                        y ? t : void 0
                                    );
                                }
                            }
                        return D.apply(this, arguments);
                    }
                }),
                (m[s] = function () {
                    var t = this || e,
                        r = arguments[0];
                    n && n.transferEventName && (r = n.transferEventName(r));
                    for (var o = [], a = Y(t, w ? w(r) : r), i = 0; i < a.length; i++) {
                        var s = a[i];
                        o.push(s.originalDelegate ? s.originalDelegate : s.callback);
                    }
                    return o;
                }),
                (m[l] = function () {
                    var t = this || e,
                        r = arguments[0];
                    if (r) {
                        n && n.transferEventName && (r = n.transferEventName(r));
                        var o = G[r];
                        if (o) {
                            var a = t[o[p]],
                                s = t[o[h]];
                            if (a) {
                                var c = a.slice();
                                for (v = 0; v < c.length; v++)
                                    this[i].call(
                                        this,
                                        r,
                                        (u = c[v]).originalDelegate ? u.originalDelegate : u.callback,
                                        u.options,
                                    );
                            }
                            if (s)
                                for (c = s.slice(), v = 0; v < c.length; v++) {
                                    var u;
                                    this[i].call(
                                        this,
                                        r,
                                        (u = c[v]).originalDelegate ? u.originalDelegate : u.callback,
                                        u.options,
                                    );
                                }
                        }
                    } else {
                        for (var f = Object.keys(t), v = 0; v < f.length; v++) {
                            var d = B.exec(f[v]),
                                _ = d && d[1];
                            _ && 'removeListener' !== _ && this[l].call(this, _);
                        }
                        this[l].call(this, 'removeListener');
                    }
                    if (y) return this;
                }),
                N(m[o], Z),
                N(m[i], D),
                C && N(m[l], C),
                O && N(m[s], O),
                !0
            );
        }
        for (var w = [], P = 0; P < n.length; P++) w[P] = E(n[P], r);
        return w;
    }
    function Y(e, t) {
        if (!t) {
            var n = [];
            for (var r in e) {
                var o = B.exec(r),
                    a = o && o[1];
                if (a && (!t || a === t)) {
                    var i = e[r];
                    if (i) for (var s = 0; s < i.length; s++) n.push(i[s]);
                }
            }
            return n;
        }
        var c = G[t];
        c || (V(t), (c = G[t]));
        var u = e[c[p]],
            l = e[c[h]];
        return u ? (l ? u.concat(l) : u.slice()) : l ? l.slice() : [];
    }
    function J(e, t) {
        var n = e.Event;
        n &&
            n.prototype &&
            t.patchMethod(n.prototype, 'stopImmediatePropagation', function (e) {
                return function (t, n) {
                    (t[U] = !0), e && e.apply(t, n);
                };
            });
    }
    function K(e, t) {
        t.patchMethod(e, 'queueMicrotask', function (e) {
            return function (e, t) {
                Zone.current.scheduleMicroTask('queueMicrotask', t[0]);
            };
        });
    }
    var $ = g('zoneTask');
    function Q(e, t, n, r) {
        var o = null,
            a = null;
        n += r;
        var i = {};
        function s(t) {
            var n = t.data;
            return (
                (n.args[0] = function () {
                    return t.invoke.apply(this, arguments);
                }),
                (n.handleId = o.apply(e, n.args)),
                t
            );
        }
        function c(t) {
            return a.call(e, t.data.handleId);
        }
        (o = R(e, (t += r), function (n) {
            return function (o, a) {
                if ('function' == typeof a[0]) {
                    var u = {
                            isPeriodic: 'Interval' === r,
                            delay: 'Timeout' === r || 'Interval' === r ? a[1] || 0 : void 0,
                            args: a,
                        },
                        l = a[0];
                    a[0] = function e() {
                        try {
                            return l.apply(this, arguments);
                        } finally {
                            u.isPeriodic ||
                                ('number' == typeof u.handleId
                                    ? delete i[u.handleId]
                                    : u.handleId && (u.handleId[$] = null));
                        }
                    };
                    var f = _(t, a[0], u, s, c);
                    if (!f) return f;
                    var h = f.data.handleId;
                    return (
                        'number' == typeof h ? (i[h] = f) : h && (h[$] = f),
                        h &&
                            h.ref &&
                            h.unref &&
                            'function' == typeof h.ref &&
                            'function' == typeof h.unref &&
                            ((f.ref = h.ref.bind(h)), (f.unref = h.unref.bind(h))),
                        'number' == typeof h || h ? h : f
                    );
                }
                return n.apply(e, a);
            };
        })),
            (a = R(e, n, function (t) {
                return function (n, r) {
                    var o,
                        a = r[0];
                    'number' == typeof a ? (o = i[a]) : (o = a && a[$]) || (o = a),
                        o && 'string' == typeof o.type
                            ? 'notScheduled' !== o.state &&
                              ((o.cancelFn && o.data.isPeriodic) || 0 === o.runCount) &&
                              ('number' == typeof a ? delete i[a] : a && (a[$] = null), o.zone.cancelTask(o))
                            : t.apply(e, r);
                };
            }));
    }
    function ee(e, t) {
        if (!Zone[t.symbol('patchEventTarget')]) {
            for (
                var n = t.getGlobalObjects(),
                    r = n.eventNames,
                    o = n.zoneSymbolEventNames,
                    a = n.TRUE_STR,
                    i = n.FALSE_STR,
                    s = n.ZONE_SYMBOL_PREFIX,
                    c = 0;
                c < r.length;
                c++
            ) {
                var u = r[c],
                    l = s + (u + i),
                    f = s + (u + a);
                (o[u] = {}), (o[u][i] = l), (o[u][a] = f);
            }
            var h = e.EventTarget;
            if (h && h.prototype) return t.patchEventTarget(e, t, [h && h.prototype]), !0;
        }
    }
    function te(e, t, n) {
        if (!n || 0 === n.length) return t;
        var r = n.filter(function (t) {
            return t.target === e;
        });
        if (!r || 0 === r.length) return t;
        var o = r[0].ignoreProperties;
        return t.filter(function (e) {
            return -1 === o.indexOf(e);
        });
    }
    function ne(e, t, n, r) {
        e && j(e, te(e, t, n), r);
    }
    function re(e) {
        return Object.getOwnPropertyNames(e)
            .filter(function (e) {
                return e.startsWith('on') && e.length > 2;
            })
            .map(function (e) {
                return e.substring(2);
            });
    }
    function oe(e, t) {
        if ((!S || Z) && !Zone[e.symbol('patchEvents')]) {
            var n = t.__Zone_ignore_on_properties,
                r = [];
            if (P) {
                var o = window;
                r = r.concat([
                    'Document',
                    'SVGElement',
                    'Element',
                    'HTMLElement',
                    'HTMLBodyElement',
                    'HTMLMediaElement',
                    'HTMLFrameSetElement',
                    'HTMLFrameElement',
                    'HTMLIFrameElement',
                    'HTMLMarqueeElement',
                    'Worker',
                ]);
                var i = (function e() {
                    try {
                        var e = y.navigator.userAgent;
                        if (-1 !== e.indexOf('MSIE ') || -1 !== e.indexOf('Trident/')) return !0;
                    } catch (e) {}
                    return !1;
                })()
                    ? [{ target: o, ignoreProperties: ['error'] }]
                    : [];
                ne(o, re(o), n ? n.concat(i) : n, a(o));
            }
            r = r.concat([
                'XMLHttpRequest',
                'XMLHttpRequestEventTarget',
                'IDBIndex',
                'IDBRequest',
                'IDBOpenDBRequest',
                'IDBDatabase',
                'IDBTransaction',
                'IDBCursor',
                'WebSocket',
            ]);
            for (var s = 0; s < r.length; s++) {
                var c = t[r[s]];
                c && c.prototype && ne(c.prototype, re(c.prototype), n);
            }
        }
    }
    function ae(e, t, n, r, o) {
        var a = Zone.__symbol__(r);
        if (!t[a]) {
            var i = (t[a] = t[r]);
            (t[r] = function (a, s, c) {
                return (
                    s &&
                        s.prototype &&
                        o.forEach(function (t) {
                            var o = ''.concat(n, '.').concat(r, '::') + t,
                                a = s.prototype;
                            try {
                                if (a.hasOwnProperty(t)) {
                                    var i = e.ObjectGetOwnPropertyDescriptor(a, t);
                                    i && i.value
                                        ? ((i.value = e.wrapWithCurrentZone(i.value, o)),
                                          e._redefineProperty(s.prototype, t, i))
                                        : a[t] && (a[t] = e.wrapWithCurrentZone(a[t], o));
                                } else a[t] && (a[t] = e.wrapWithCurrentZone(a[t], o));
                            } catch (e) {}
                        }),
                    i.call(t, a, s, c)
                );
            }),
                e.attachOriginToPatched(t[r], i);
        }
    }
    var ie = (function se() {
        var e,
            r = globalThis,
            o = !0 === r[t('forceDuplicateZoneCheck')];
        if (r.Zone && (o || 'function' != typeof r.Zone.__symbol__)) throw new Error('Zone already loaded.');
        return (null !== (e = r.Zone) && void 0 !== e) || (r.Zone = n()), r.Zone;
    })();
    !(function ce(e) {
        (function t(e) {
            e.__load_patch('ZoneAwarePromise', function (e, t, n) {
                var r = Object.getOwnPropertyDescriptor,
                    o = Object.defineProperty,
                    a = n.symbol,
                    i = [],
                    s = !1 !== e[a('DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION')],
                    c = a('Promise'),
                    u = a('then'),
                    l = '__creationTrace__';
                (n.onUnhandledError = function (e) {
                    if (n.showUncaughtError()) {
                        var t = e && e.rejection;
                        t
                            ? console.error(
                                  'Unhandled Promise rejection:',
                                  t instanceof Error ? t.message : t,
                                  '; Zone:',
                                  e.zone.name,
                                  '; Task:',
                                  e.task && e.task.source,
                                  '; Value:',
                                  t,
                                  t instanceof Error ? t.stack : void 0,
                              )
                            : console.error(e);
                    }
                }),
                    (n.microtaskDrainDone = function () {
                        for (
                            var e = function () {
                                var e = i.shift();
                                try {
                                    e.zone.runGuarded(function () {
                                        if (e.throwOriginal) throw e.rejection;
                                        throw e;
                                    });
                                } catch (e) {
                                    !(function r(e) {
                                        n.onUnhandledError(e);
                                        try {
                                            var r = t[f];
                                            'function' == typeof r && r.call(this, e);
                                        } catch (e) {}
                                    })(e);
                                }
                            };
                            i.length;

                        )
                            e();
                    });
                var f = a('unhandledPromiseRejectionHandler');
                function h(e) {
                    return e && e.then;
                }
                function p(e) {
                    return e;
                }
                function v(e) {
                    return N.reject(e);
                }
                var d = a('state'),
                    _ = a('value'),
                    g = a('finally'),
                    k = a('parentPromiseValue'),
                    y = a('parentPromiseState'),
                    m = 'Promise.then',
                    T = null,
                    b = !0,
                    E = !1,
                    w = 0;
                function S(e, t) {
                    return function (n) {
                        try {
                            O(e, t, n);
                        } catch (t) {
                            O(e, !1, t);
                        }
                    };
                }
                var P = function () {
                        var e = !1;
                        return function t(n) {
                            return function () {
                                e || ((e = !0), n.apply(null, arguments));
                            };
                        };
                    },
                    Z = 'Promise resolved with itself',
                    D = a('currentTaskTrace');
                function O(e, r, a) {
                    var c = P();
                    if (e === a) throw new TypeError(Z);
                    if (e[d] === T) {
                        var u = null;
                        try {
                            ('object' != typeof a && 'function' != typeof a) || (u = a && a.then);
                        } catch (t) {
                            return (
                                c(function () {
                                    O(e, !1, t);
                                })(),
                                e
                            );
                        }
                        if (r !== E && a instanceof N && a.hasOwnProperty(d) && a.hasOwnProperty(_) && a[d] !== T)
                            j(a), O(e, a[d], a[_]);
                        else if (r !== E && 'function' == typeof u)
                            try {
                                u.call(a, c(S(e, r)), c(S(e, !1)));
                            } catch (t) {
                                c(function () {
                                    O(e, !1, t);
                                })();
                            }
                        else {
                            e[d] = r;
                            var f = e[_];
                            if (
                                ((e[_] = a),
                                e[g] === g && r === b && ((e[d] = e[y]), (e[_] = e[k])),
                                r === E && a instanceof Error)
                            ) {
                                var h = t.currentTask && t.currentTask.data && t.currentTask.data[l];
                                h && o(a, D, { configurable: !0, enumerable: !1, writable: !0, value: h });
                            }
                            for (var p = 0; p < f.length; ) z(e, f[p++], f[p++], f[p++], f[p++]);
                            if (0 == f.length && r == E) {
                                e[d] = w;
                                var v = a;
                                try {
                                    throw new Error(
                                        'Uncaught (in promise): ' +
                                            (function e(t) {
                                                return t && t.toString === Object.prototype.toString
                                                    ? ((t.constructor && t.constructor.name) || '') +
                                                          ': ' +
                                                          JSON.stringify(t)
                                                    : t
                                                    ? t.toString()
                                                    : Object.prototype.toString.call(t);
                                            })(a) +
                                            (a && a.stack ? '\n' + a.stack : ''),
                                    );
                                } catch (e) {
                                    v = e;
                                }
                                s && (v.throwOriginal = !0),
                                    (v.rejection = a),
                                    (v.promise = e),
                                    (v.zone = t.current),
                                    (v.task = t.currentTask),
                                    i.push(v),
                                    n.scheduleMicroTask();
                            }
                        }
                    }
                    return e;
                }
                var C = a('rejectionHandledHandler');
                function j(e) {
                    if (e[d] === w) {
                        try {
                            var n = t[C];
                            n && 'function' == typeof n && n.call(this, { rejection: e[_], promise: e });
                        } catch (e) {}
                        e[d] = E;
                        for (var r = 0; r < i.length; r++) e === i[r].promise && i.splice(r, 1);
                    }
                }
                function z(e, t, n, r, o) {
                    j(e);
                    var a = e[d],
                        i = a ? ('function' == typeof r ? r : p) : 'function' == typeof o ? o : v;
                    t.scheduleMicroTask(
                        m,
                        function () {
                            try {
                                var r = e[_],
                                    o = !!n && g === n[g];
                                o && ((n[k] = r), (n[y] = a));
                                var s = t.run(i, void 0, o && i !== v && i !== p ? [] : [r]);
                                O(n, !0, s);
                            } catch (e) {
                                O(n, !1, e);
                            }
                        },
                        n,
                    );
                }
                var I = function () {},
                    M = e.AggregateError,
                    N = (function () {
                        function e(t) {
                            var n = this;
                            if (!(n instanceof e)) throw new Error('Must be an instanceof Promise.');
                            (n[d] = T), (n[_] = []);
                            try {
                                var r = P();
                                t && t(r(S(n, b)), r(S(n, E)));
                            } catch (e) {
                                O(n, !1, e);
                            }
                        }
                        return (
                            (e.toString = function () {
                                return 'function ZoneAwarePromise() { [native code] }';
                            }),
                            (e.resolve = function (t) {
                                return t instanceof e ? t : O(new this(null), b, t);
                            }),
                            (e.reject = function (e) {
                                return O(new this(null), E, e);
                            }),
                            (e.withResolvers = function () {
                                var t = {};
                                return (
                                    (t.promise = new e(function (e, n) {
                                        (t.resolve = e), (t.reject = n);
                                    })),
                                    t
                                );
                            }),
                            (e.any = function (t) {
                                if (!t || 'function' != typeof t[Symbol.iterator])
                                    return Promise.reject(new M([], 'All promises were rejected'));
                                var n = [],
                                    r = 0;
                                try {
                                    for (var o = 0, a = t; o < a.length; o++) r++, n.push(e.resolve(a[o]));
                                } catch (e) {
                                    return Promise.reject(new M([], 'All promises were rejected'));
                                }
                                if (0 === r) return Promise.reject(new M([], 'All promises were rejected'));
                                var i = !1,
                                    s = [];
                                return new e(function (e, t) {
                                    for (var o = 0; o < n.length; o++)
                                        n[o].then(
                                            function (t) {
                                                i || ((i = !0), e(t));
                                            },
                                            function (e) {
                                                s.push(e),
                                                    0 == --r && ((i = !0), t(new M(s, 'All promises were rejected')));
                                            },
                                        );
                                });
                            }),
                            (e.race = function (e) {
                                var t,
                                    n,
                                    r = new this(function (e, r) {
                                        (t = e), (n = r);
                                    });
                                function o(e) {
                                    t(e);
                                }
                                function a(e) {
                                    n(e);
                                }
                                for (var i = 0, s = e; i < s.length; i++) {
                                    var c = s[i];
                                    h(c) || (c = this.resolve(c)), c.then(o, a);
                                }
                                return r;
                            }),
                            (e.all = function (t) {
                                return e.allWithCallback(t);
                            }),
                            (e.allSettled = function (t) {
                                return (this && this.prototype instanceof e ? this : e).allWithCallback(t, {
                                    thenCallback: function (e) {
                                        return { status: 'fulfilled', value: e };
                                    },
                                    errorCallback: function (e) {
                                        return { status: 'rejected', reason: e };
                                    },
                                });
                            }),
                            (e.allWithCallback = function (e, t) {
                                for (
                                    var n,
                                        r,
                                        o = new this(function (e, t) {
                                            (n = e), (r = t);
                                        }),
                                        a = 2,
                                        i = 0,
                                        s = [],
                                        c = function (e) {
                                            h(e) || (e = u.resolve(e));
                                            var o = i;
                                            try {
                                                e.then(
                                                    function (e) {
                                                        (s[o] = t ? t.thenCallback(e) : e), 0 == --a && n(s);
                                                    },
                                                    function (e) {
                                                        t ? ((s[o] = t.errorCallback(e)), 0 == --a && n(s)) : r(e);
                                                    },
                                                );
                                            } catch (e) {
                                                r(e);
                                            }
                                            a++, i++;
                                        },
                                        u = this,
                                        l = 0,
                                        f = e;
                                    l < f.length;
                                    l++
                                )
                                    c(f[l]);
                                return 0 == (a -= 2) && n(s), o;
                            }),
                            Object.defineProperty(e.prototype, Symbol.toStringTag, {
                                get: function () {
                                    return 'Promise';
                                },
                                enumerable: !1,
                                configurable: !0,
                            }),
                            Object.defineProperty(e.prototype, Symbol.species, {
                                get: function () {
                                    return e;
                                },
                                enumerable: !1,
                                configurable: !0,
                            }),
                            (e.prototype.then = function (n, r) {
                                var o,
                                    a = null === (o = this.constructor) || void 0 === o ? void 0 : o[Symbol.species];
                                (a && 'function' == typeof a) || (a = this.constructor || e);
                                var i = new a(I),
                                    s = t.current;
                                return this[d] == T ? this[_].push(s, i, n, r) : z(this, s, i, n, r), i;
                            }),
                            (e.prototype.catch = function (e) {
                                return this.then(null, e);
                            }),
                            (e.prototype.finally = function (n) {
                                var r,
                                    o = null === (r = this.constructor) || void 0 === r ? void 0 : r[Symbol.species];
                                (o && 'function' == typeof o) || (o = e);
                                var a = new o(I);
                                a[g] = g;
                                var i = t.current;
                                return this[d] == T ? this[_].push(i, a, n, n) : z(this, i, a, n, n), a;
                            }),
                            e
                        );
                    })();
                (N.resolve = N.resolve), (N.reject = N.reject), (N.race = N.race), (N.all = N.all);
                var A = (e[c] = e.Promise);
                e.Promise = N;
                var L = a('thenPatched');
                function H(e) {
                    var t = e.prototype,
                        n = r(t, 'then');
                    if (!n || (!1 !== n.writable && n.configurable)) {
                        var o = t.then;
                        (t[u] = o),
                            (e.prototype.then = function (e, t) {
                                var n = this;
                                return new N(function (e, t) {
                                    o.call(n, e, t);
                                }).then(e, t);
                            }),
                            (e[L] = !0);
                    }
                }
                return (
                    (n.patchThen = H),
                    A &&
                        (H(A),
                        R(e, 'fetch', function (e) {
                            return (function t(e) {
                                return function (t, n) {
                                    var r = e.apply(t, n);
                                    if (r instanceof N) return r;
                                    var o = r.constructor;
                                    return o[L] || H(o), r;
                                };
                            })(e);
                        })),
                    (Promise[t.__symbol__('uncaughtPromiseErrors')] = i),
                    N
                );
            });
        })(e),
            (function n(e) {
                e.__load_patch('toString', function (e) {
                    var t = Function.prototype.toString,
                        n = g('OriginalDelegate'),
                        r = g('Promise'),
                        o = g('Error'),
                        a = function a() {
                            if ('function' == typeof this) {
                                var i = this[n];
                                if (i) return 'function' == typeof i ? t.call(i) : Object.prototype.toString.call(i);
                                if (this === Promise) {
                                    var s = e[r];
                                    if (s) return t.call(s);
                                }
                                if (this === Error) {
                                    var c = e[o];
                                    if (c) return t.call(c);
                                }
                            }
                            return t.call(this);
                        };
                    (a[n] = t), (Function.prototype.toString = a);
                    var i = Object.prototype.toString;
                    Object.prototype.toString = function () {
                        return 'function' == typeof Promise && this instanceof Promise
                            ? '[object Promise]'
                            : i.call(this);
                    };
                });
            })(e),
            (function a(e) {
                e.__load_patch('util', function (e, t, n) {
                    var a = re(e);
                    (n.patchOnProperties = j), (n.patchMethod = R), (n.bindArguments = b), (n.patchMacroTask = M);
                    var l = t.__symbol__('BLACK_LISTED_EVENTS'),
                        f = t.__symbol__('UNPATCHED_EVENTS');
                    e[f] && (e[l] = e[f]),
                        e[l] && (t[l] = t[f] = e[l]),
                        (n.patchEventPrototype = J),
                        (n.patchEventTarget = X),
                        (n.isIEOrEdge = H),
                        (n.ObjectDefineProperty = o),
                        (n.ObjectGetOwnPropertyDescriptor = r),
                        (n.ObjectCreate = i),
                        (n.ArraySlice = s),
                        (n.patchClass = I),
                        (n.wrapWithCurrentZone = d),
                        (n.filterProperties = te),
                        (n.attachOriginToPatched = N),
                        (n._redefineProperty = Object.defineProperty),
                        (n.patchCallbacks = ae),
                        (n.getGlobalObjects = function () {
                            return {
                                globalSources: W,
                                zoneSymbolEventNames: G,
                                eventNames: a,
                                isBrowser: P,
                                isMix: Z,
                                isNode: S,
                                TRUE_STR: h,
                                FALSE_STR: p,
                                ZONE_SYMBOL_PREFIX: v,
                                ADD_EVENT_LISTENER_STR: c,
                                REMOVE_EVENT_LISTENER_STR: u,
                            };
                        });
                });
            })(e);
    })(ie),
        (function ue(e) {
            e.__load_patch('legacy', function (t) {
                var n = t[e.__symbol__('legacyPatch')];
                n && n();
            }),
                e.__load_patch('timers', function (e) {
                    var t = 'set',
                        n = 'clear';
                    Q(e, t, n, 'Timeout'), Q(e, t, n, 'Interval'), Q(e, t, n, 'Immediate');
                }),
                e.__load_patch('requestAnimationFrame', function (e) {
                    Q(e, 'request', 'cancel', 'AnimationFrame'),
                        Q(e, 'mozRequest', 'mozCancel', 'AnimationFrame'),
                        Q(e, 'webkitRequest', 'webkitCancel', 'AnimationFrame');
                }),
                e.__load_patch('blocking', function (e, t) {
                    for (var n = ['alert', 'prompt', 'confirm'], r = 0; r < n.length; r++)
                        R(e, n[r], function (n, r, o) {
                            return function (r, a) {
                                return t.current.run(n, e, a, o);
                            };
                        });
                }),
                e.__load_patch('EventTarget', function (e, t, n) {
                    !(function r(e, t) {
                        t.patchEventPrototype(e, t);
                    })(e, n),
                        ee(e, n);
                    var o = e.XMLHttpRequestEventTarget;
                    o && o.prototype && n.patchEventTarget(e, n, [o.prototype]);
                }),
                e.__load_patch('MutationObserver', function (e, t, n) {
                    I('MutationObserver'), I('WebKitMutationObserver');
                }),
                e.__load_patch('IntersectionObserver', function (e, t, n) {
                    I('IntersectionObserver');
                }),
                e.__load_patch('FileReader', function (e, t, n) {
                    I('FileReader');
                }),
                e.__load_patch('on_property', function (e, t, n) {
                    oe(n, e);
                }),
                e.__load_patch('customElements', function (e, t, n) {
                    !(function r(e, t) {
                        var n = t.getGlobalObjects();
                        (n.isBrowser || n.isMix) &&
                            e.customElements &&
                            'customElements' in e &&
                            t.patchCallbacks(t, e.customElements, 'customElements', 'define', [
                                'connectedCallback',
                                'disconnectedCallback',
                                'adoptedCallback',
                                'attributeChangedCallback',
                                'formAssociatedCallback',
                                'formDisabledCallback',
                                'formResetCallback',
                                'formStateRestoreCallback',
                            ]);
                    })(e, n);
                }),
                e.__load_patch('XHR', function (e, t) {
                    !(function n(e) {
                        var n = e.XMLHttpRequest;
                        if (n) {
                            var u = n.prototype,
                                h = u[l],
                                p = u[f];
                            if (!h) {
                                var v = e.XMLHttpRequestEventTarget;
                                if (v) {
                                    var d = v.prototype;
                                    (h = d[l]), (p = d[f]);
                                }
                            }
                            var k = 'readystatechange',
                                y = 'scheduled',
                                m = R(u, 'open', function () {
                                    return function (e, t) {
                                        return (e[o] = 0 == t[2]), (e[s] = t[1]), m.apply(e, t);
                                    };
                                }),
                                T = g('fetchTaskAborting'),
                                b = g('fetchTaskScheduling'),
                                E = R(u, 'send', function () {
                                    return function (e, n) {
                                        if (!0 === t.current[b]) return E.apply(e, n);
                                        if (e[o]) return E.apply(e, n);
                                        var r = { target: e, url: e[s], isPeriodic: !1, args: n, aborted: !1 },
                                            a = _('XMLHttpRequest.send', P, r, S, Z);
                                        e && !0 === e[c] && !r.aborted && a.state === y && a.invoke();
                                    };
                                }),
                                w = R(u, 'abort', function () {
                                    return function (e, n) {
                                        var o = (function a(e) {
                                            return e[r];
                                        })(e);
                                        if (o && 'string' == typeof o.type) {
                                            if (null == o.cancelFn || (o.data && o.data.aborted)) return;
                                            o.zone.cancelTask(o);
                                        } else if (!0 === t.current[T]) return w.apply(e, n);
                                    };
                                });
                        }
                        function S(e) {
                            var n = e.data,
                                o = n.target;
                            (o[i] = !1), (o[c] = !1);
                            var s = o[a];
                            h || ((h = o[l]), (p = o[f])), s && p.call(o, k, s);
                            var u = (o[a] = function () {
                                if (o.readyState === o.DONE)
                                    if (!n.aborted && o[i] && e.state === y) {
                                        var r = o[t.__symbol__('loadfalse')];
                                        if (0 !== o.status && r && r.length > 0) {
                                            var a = e.invoke;
                                            (e.invoke = function () {
                                                for (var r = o[t.__symbol__('loadfalse')], i = 0; i < r.length; i++)
                                                    r[i] === e && r.splice(i, 1);
                                                n.aborted || e.state !== y || a.call(e);
                                            }),
                                                r.push(e);
                                        } else e.invoke();
                                    } else n.aborted || !1 !== o[i] || (o[c] = !0);
                            });
                            return h.call(o, k, u), o[r] || (o[r] = e), E.apply(o, n.args), (o[i] = !0), e;
                        }
                        function P() {}
                        function Z(e) {
                            var t = e.data;
                            return (t.aborted = !0), w.apply(t.target, t.args);
                        }
                    })(e);
                    var r = g('xhrTask'),
                        o = g('xhrSync'),
                        a = g('xhrListener'),
                        i = g('xhrScheduled'),
                        s = g('xhrURL'),
                        c = g('xhrErrorBeforeScheduled');
                }),
                e.__load_patch('geolocation', function (e) {
                    e.navigator &&
                        e.navigator.geolocation &&
                        (function t(e, n) {
                            for (
                                var o = e.constructor.name,
                                    a = function (t) {
                                        var a = n[t],
                                            i = e[a];
                                        if (i) {
                                            if (!E(r(e, a))) return 'continue';
                                            e[a] = (function (e) {
                                                var t = function () {
                                                    return e.apply(this, b(arguments, o + '.' + a));
                                                };
                                                return N(t, e), t;
                                            })(i);
                                        }
                                    },
                                    i = 0;
                                i < n.length;
                                i++
                            )
                                a(i);
                        })(e.navigator.geolocation, ['getCurrentPosition', 'watchPosition']);
                }),
                e.__load_patch('PromiseRejectionEvent', function (e, t) {
                    function n(t) {
                        return function (n) {
                            Y(e, t).forEach(function (r) {
                                var o = e.PromiseRejectionEvent;
                                if (o) {
                                    var a = new o(t, { promise: n.promise, reason: n.rejection });
                                    r.invoke(a);
                                }
                            });
                        };
                    }
                    e.PromiseRejectionEvent &&
                        ((t[g('unhandledPromiseRejectionHandler')] = n('unhandledrejection')),
                        (t[g('rejectionHandledHandler')] = n('rejectionhandled')));
                }),
                e.__load_patch('queueMicrotask', function (e, t, n) {
                    K(e, n);
                });
        })(ie);
});
